import { Box, Icon, Typography } from '@mui/material'
import React, { useState } from 'react'
import AdxStatusBar from 'components/reusable/statusBar/AdxStatusBar'
import LinearProgressBar from '../../viewForm/components/linearProgressBar'
import CancelSubmitModal from '../../viewForm/components/cancelSubmitModal'

const EDFormHeader = ({
  title,
  isPreview = true,
  isSubmit = false,
  pageCount,
  pageCurrent,
  handleExit,
}) => {
  const [isModalOpen, setModalOpen] = useState(false)

  const handleOpen = () => {
    setModalOpen(true)
  }

  return (
    <>
      <Box
        sx={{
          width: '100%',
          height: 75,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: 'white.main',
          borderBottom: '1px solid',
          borderBottomColor: 'gray-line.main',
          position: 'sticky',
          top: 0,
          zIndex: 999,
        }}
        px={'40px'}
      >
        <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
          <Typography variant="h4">{title}</Typography>
          {isPreview ? (
            <AdxStatusBar
              status={{
                text: 'Preview',
                color: 'alternate.main',
                bgColor: 'alternate.light',
              }}
              py={1 / 3}
              sx={{ borderRadius: '4.5px' }}
            />
          ) : null}
        </Box>
        <Box display="flex" alignItems="center" gap={3}>
          <Icon
            onClick={
              isSubmit
                ? handleOpen
                : () => {
                    handleExit()
                  }
            }
            sx={{ fontSize: 25, cursor: 'pointer' }}
          >
            close
          </Icon>
        </Box>
        {isSubmit && (
          <Box
            sx={{
              width: '100%',
              position: 'absolute',
              left: 0,
              bottom: 0,
            }}
          >
            <LinearProgressBar value={((pageCurrent + 1) / pageCount) * 100} />
          </Box>
        )}
      </Box>

      {/* Close submit form modal */}
      <CancelSubmitModal isModalOpen={isModalOpen} setModalOpen={setModalOpen} />
    </>
  )
}

export default EDFormHeader
